import React from 'react';

// 기타 react
import { FormattedMessage } from 'react-intl';

import GridContainer from "components/react-template/Grid/GridContainer.jsx";
import GridItem from "components/react-template/Grid/GridItem.jsx";

class NotFound extends React.Component {

    goHistoryBack = () => {
        this.props.history.goBack() ;
    }

    goMainPage = () => {
        this.props.history.push({
            pathname: "/",
        });
    }

    render() {

        return (
            <div>
                <GridContainer justify={"space-between"} alignItems={"center"} direction={"column"} className={"error-container"}>
                    <GridItem></GridItem>
                    <GridItem className={"error-body"}>
                        <div className={'error-title'}><FormattedMessage id="page.not.found.title" /></div>
                        <div className={'error-sub'}>
                            <FormattedMessage id="page.not.found.desc.01" /> 
                            <br/>
                            <FormattedMessage id="page.not.found.desc.02" />
                        </div>
                        <div className={'error-button'}>
                            <button
                                onClick={this.goMainPage}
                            >
                                <FormattedMessage id="common.move.main.page" />
                            </button>
                            <button 
                                className={'last'}
                                onClick={this.goHistoryBack}
                            >
                                <FormattedMessage id="common.move.prev.page" />
                            </button>
                        </div>
                    </GridItem>
                    <GridItem className={"error-footer"}>
                        <FormattedMessage id="common.copyright" />
                    </GridItem>
                </GridContainer>
            </div>
        );
    }

};

NotFound.propTypes = {
    
};

export default NotFound;